export const formatToFinancialAmountString = (amount: number | string) =>
  (typeof amount === "string" ? amount : String(amount)).replace(
    /\B(?=(\d{3})+(?!\d))/g,
    "'",
  );
